<template>
    <Navbar/>
    <TokenBody/>
    <Footer/>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import Navbar from "@/components/NavbarBody.vue";
  import TokenBody from "@/components/TokenBody.vue";
  import Footer from "@/components/FooterBody.vue"; 
  
  export default defineComponent({
    name: "TokenView",
    components: {
      Navbar,
      TokenBody,
      Footer
    },
  });
  </script>
  